import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DataItem, SummaryItem, SummaryPage, SummaryPageChartData } from '../report.model';
import { ChartComponent } from '../../chart/chart.component';
import { Disclaimer, PoweredBy } from '../report.constants';

@Component({
  selector: 'summary-report',
  standalone: true,
  imports: [CommonModule, ChartComponent],
  templateUrl: './summary-report.component.html',
  styleUrl: './summary-report.component.scss',
})
export class SummaryReportComponent {
  calculatedData: DataItem[] = [];
  summaryData: SummaryItem[] = [];
  readonly disclaimer: string = Disclaimer;
  readonly poweredBy: string = PoweredBy;

  @Input() summaryDataObj!: SummaryPage;
  @Input() chartData: SummaryPageChartData = { channelData: [], resolutionData: [] };

  ngOnInit() {
    this.calculatedData = [
      { dataTitle: 'Date Range', dataValue: this.summaryDataObj.dateRange },
      { dataTitle: 'Aeroplan Number', dataValue: this.summaryDataObj.aeroplaneNumber },
      { dataTitle: 'Phone Number', dataValue: this.summaryDataObj.phoneNumber },
      { dataTitle: 'Total Interactions', dataValue: this.summaryDataObj.totalConversations },
      { dataTitle: 'Avg. Queue Wait Time', dataValue: this.summaryDataObj.averageQueueWaitTime },
      { dataTitle: 'Avg. Call Hold Time', dataValue: this.summaryDataObj.averageHoldTime },
      { dataTitle: 'Avg. Interaction Time', dataValue: this.summaryDataObj.averageInteractionTime },
      { dataTitle: 'Total Primary Topics', dataValue: this.summaryDataObj.totalPrimaryTopics },
      { dataTitle: 'Total Topics', dataValue: this.summaryDataObj.totalTopics },
      { dataTitle: 'Total Root Causes', dataValue: this.summaryDataObj.totalRootCauses },
    ];

    this.summaryData = [
      {
        dataTitle: 'Problem',
        dataValue:
          'The customer contacted the airline’s support center for help rebooking a missed flight due to an unexpected delay and understanding related fees. They also needed clarification on baggage allowance, including weight limits and extra charges. Additionally, they faced a seat selection issue where their chosen seat was unavailable despite prior confirmation. Lastly, they requested a refund for an incorrect charge and sought guidance on the process and expected timelines.',
      },
      {
        dataTitle: 'Most Interactions Involved',
        dataValue: this.summaryDataObj.listOfPrimaryTopics,
      },
      {
        dataTitle: 'Top Root Causes',
        dataValue: this.summaryDataObj.listofRootCauses,
      },
      {
        dataTitle: 'Recent Conversations Overview',
        dataValue:
          'Rebooked missed flight and discussed fees., Clarified baggage allowance and weight limits for upcoming flight., Addressed seat selection issue and availability., Requested refund for incorrect charge and process details., Inquired about refund timelines and steps.',
      },
    ];
  }
}
